import { render, staticRenderFns } from "./NowBoarding.vue?vue&type=template&id=4f0133fc&scoped=true&"
import script from "./NowBoarding.vue?vue&type=script&lang=js&"
export * from "./NowBoarding.vue?vue&type=script&lang=js&"
import style0 from "./NowBoarding.vue?vue&type=style&index=0&id=4f0133fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0133fc",
  null
  
)

export default component.exports